import { paths } from '@/config/paths';
import { logout } from '@/features/auth';
import { noop } from '@/lib/utils';
import { isWebview, postToHost } from '@/lib/webview-bridge';

/** Public routes that should not redirect to login on 401 */
const PUBLIC_ROUTES = [paths.app.batchPausePolicy.path];

export const handleLogout = () => {
  logout()
    .catch(() => noop())
    .finally(() => {
      if (isWebview()) {
        postToHost({ type: 'AUTH_REQUIRED' });
        return;
      }
      const { pathname } = globalThis.location;
      const isOnAuthPage = pathname.includes(paths.auth.root.path);
      const isOnPublicRoute = PUBLIC_ROUTES.some(
        route => pathname === route || pathname.startsWith(`${route}/`)
      );
      if (!isOnAuthPage && !isOnPublicRoute) {
        globalThis.location.href = paths.auth.login.getHref();
      }
    });
};
